<template>
  <header class="header_goods">
    <meta name="viewport" content="width=device-width,intial-scale=0,maximum-scale=0,user-scalable=yes,shrink-to-fit=no">
    <div class="header_content1">
      <div class="header_logo">
        <img :src="require('@/assets/img/logo.png')" />
      </div>
    </div>
  </header>
</template>
<script>
/* eslint-disable */
import Cookies from 'js-cookie'
import * as commfun from "@/common/common.js"
export default {
  name: 'Smainl',
  data() {
    return {

    };
  },
  created() {
  },
  computed: {

  },
  methods: {
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Smainl.vue